import { GameProvider } from '../enums'

// GAMES API
export const GAMES_API = {
  TOP_WINNERS: '/top-winning',
  GAMES: '/games',
  GAME_IDS_FILTER: '/games/filter/ids',
  CATEGORIES: '/games/categories',
  PROVIDERS: '/games/providers',
  LIVE_CASINO: '/games/livecasino',
  PLAY: '/games/play',
  JACKPOT: '/games/jackpot',
  TOP_RANKINGS: '/top-sport-event/top-sport-event-rankings'
}

// Iframe game api
export const IFRAME_GAME_API = {
  A_SPORTS: `${GAMES_API.PLAY}?provider=athena-sports`,
  VIRTUAL_SPORTS: `${GAMES_API.PLAY}?provider=athena-virtual-sports`,
  ESPORTS: `${GAMES_API.PLAY}?provider=athena-e-sports`,
  VIRTUAL_GAME: 'games/url?gameName=virtual-game',
  TABLE_GAMES: `${GAMES_API.PLAY}?provider=${GameProvider.SABA}&gameType=table-game`,
  SABA_CLUB: `${GAMES_API.PLAY}?provider=${GameProvider.SABA}&gameType=saba-club`,
  NUMBER_GAME: `${GAMES_API.PLAY}?provider=${GameProvider.SABA}&gameType=number-game`,
  KENO: `${GAMES_API.PLAY}?provider=${GameProvider.SABA}&gameType=keno`,
  LOTTERY: `${GAMES_API.PLAY}?provider=${GameProvider.SABA}&gameType=lottery`,
  VIRTUAL_CASINO: 'games/url?gameName=virtual-casino',
  M_SPORTS: `${GAMES_API.PLAY}?provider=im-sports`,
  K_SPORTS: `${GAMES_API.PLAY}?provider=k-sports`,
  C_SPORTS: `${GAMES_API.PLAY}?provider=bti-sports`,
  V_GAMING: `${GAMES_API.PLAY}?provider=${GameProvider.SABA}&gameType=v-gaming`
}
